import cx from "classnames";
import { PropsWithChildren } from "react";
import Styles from "./List.module.scss";

type ListProps = {
  type: string;
  level: number;
} & PropsWithChildren;

const List = ({ children, type, level }: ListProps) => {
  const className = cx(Styles.list, {
    [Styles.bullet]: type === "bullet" && level % 3 === 1,
    [Styles.circle]: type === "bullet" && level % 3 === 2,
    [Styles.square]: type === "bullet" && level % 3 === 0,
    [Styles.number]: type === "number" && level % 3 === 1,
    [Styles.lowerAlpha]: type === "number" && level % 3 === 2,
    [Styles.lowerRoman]: type === "number" && level % 3 === 0,
  });

  const listMap = {
    bullet: <ul className={className}>{children}</ul>,
    number: <ol className={className}>{children}</ol>,
  };

  return listMap[type as keyof typeof listMap];
};

export default List;
